import {select} from 'd3-selection';
import {transition} from 'd3-transition';
import {className} from '../../modules/util';
function renderRegion(localFunc, dataFunc = d => d, isFacet = false, suffix = '') {
  let region = this.__execs__.canvas.select(className('regions', true))
    .selectAll(this.regionName() + (isFacet ? '.facet' : '') + suffix, (d,i) => d.data.key ? d.data.key : i)
    .data(dataFunc);
  const regionName = this.regionName().split('.').join(' ').trim();
  const aggregated = this.aggregated();
  const regionClass = regionName + (isFacet ? ' facet' : '');
  const canvas = this.__execs__.canvas;
  const trans = transition().duration(this.transition().duration).delay(this.transition().delay); 
  const _id = canvas.selectAll(className('canvas-g-clip-path', true)).attr('id');
  let _regionInit = function (selection) {
    selection.each(function(xy) {
      if (!aggregated) select(this).attr('transform', 'translate(' + [xy.x, xy.y] + ')');
      if (_id && !isFacet) select(this).attr('clip-path', 'url(#' + _id+')'); //FIXME : facet의 parent인 경우 그리지 않기
    })
  };
  let _region = function (selection) {
    selection.each(function(xy) {
      if (!aggregated) select(this).transition(trans).attr('transform', 'translate(' + [xy.x, xy.y] + ')');  
    })
  };
  
  region.exit().remove();
  let regionEnter = region.enter().append('g')
      .attr('class', regionClass)
      .each(localFunc)
      .call(_regionInit)
  region.each(localFunc);
  region = regionEnter.merge(region);
  region.call(_region);
  return region;
}

export default renderRegion;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/renderRegion.js